import { Routes } from '@angular/router';

import { LoginComponent } from '../../login/login.component';
import { ForgetPasswordComponent } from '../../forgetpassword/forgetpassword.component';
import { FeedBackComponent } from '../../feedback/feedback.component';
import {RestPasswordComponent} from '../../restpassword/restpassword.component';
import { ChangePasswordComponent } from 'app/ChangePassword/ChangePassword.component';
export const AdminLayoutRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'forgetpassword', component: ForgetPasswordComponent },
  { path: 'feedback', component: FeedBackComponent },
  { path: 'change-password', component: RestPasswordComponent },
  { path: 'changepassword', component: ChangePasswordComponent }

];

